import { FC } from 'react';
import { BaseInputProps } from '../typings/InputProps';

export const DropdownInput: FC<BaseInputProps> = (props) => {
	return <Dropdown selectObject={null} label={props.label} />;
};

export const Dropdown: FC<{
	selectObject: any;
	label?: string;
}> = (props) => {
	return null;
};
